export default {
  metaTitle: '店铺设置',
  pageTitle: '店铺设置',
  country: '基于国家站',
  placeholder1: '名称',
  logo: '上传店铺LOGO',
  placeholder2: '选择省份',
  placeholder3: '选择城市',
  selectAdress: '业务所属地',
  main1: '请填写邮件地址以便于收到系统发送的清结算帐单以及其它活动相关信息。如果您不想收到这些信息请勿填写。',
  eCourierBranch: 'eCourier pick branch',
  save: '保存',
  main2: '申请店铺扩展到其他国家站',
  main3: '抱歉，当前没有可扩展的国家站可选择',
  main4: '提交申请',
  main5: '申请记录和状态',
  applyLog: '申请日志',
  storeStatus: '店铺状态',
  radio1: '营业中',
  radio2: '歇业',
  main6: '您仅针对已开放的国家站设置店铺歇业状态',
  setting: '店铺发货设置',
  English: '英文',
  contactPerson: '联系人',
  tel: '电话',
  province: '省市',
  address: '详细地址',
  Chinese: '中文',
  transitWarehouseSelection: '发货到的中转仓选择',
  generalCargo: '普货',
  recipient: '收件人',
  select1: '非普货',
  select2: '电，磁，粉末或压缩剂',
  expandRegionId: '扩展国id',
  applyFailed: '申请失败',
  applySuccess: '申请成功',
  statusList1: '待审核',
  statusList2: '已审核',
  statusList3: '已拒绝',
  errorTips1: 'Email填写长度不能超过50个字符',
  errorTips2: 'Email格式不正确',
  errorTips3: '请选择国家站点',
  successTips1: '提交成功',
  errorTips4: '请填写英文相关地址信息',
  errorTips5: '请填写中文相关地址信息',
  errorTips6: '请勾选要扩展的国家站点',
  errorTipsArea: '请选择最后一级城市',
  emptyEmail: '邮箱不能为空',
  expandPaymentNewMarkets: '扩展新市场的支付协议提醒',
  youPreparingSubmitAgreement: '你正在提交店铺扩展到新国家市场的申请,需要阅读并同意相应国家支付协议才能继续',
  iHaveReadAndAgreeMoveOn: '我已阅读并同意,继续',
  readAndAgreeThePaymentAgreement: '请阅读并同意相关支付协议',
  imageRequirements: '图片要求：宽高相等且小于 1 Mb。',
  storeLevelDeliveryFee: '店铺级运费设置',
  fillEmailAndPhone: '填写邮箱、手机号码和What\'s App Number, 以便接收平台通知或接收重要文件。',
  selectCountry: '选择区号',
  phoneNumber: '手机号码',
  storeNameSupportLetter: '店铺名称仅支持英文字母，数字和空格',
  inputEmail: '请输入邮箱',

  source: '归属',
  confirm: '确认',
  cancel: '取消',
  revision: '修订',
  settingLabel: '设置',
  enterCode: '请输入验证码',
  enterEmail: '请输入邮箱',
  enterWA: '请输入WhatsApp',
  enterPhone: '请输入手机号',
  setEmail: '设置接收提醒邮箱',
  setWhatsapp: '设置接收提醒WhatsApp number',
  setPhoneTips: '设置接收提醒电话号码',
  emailError: '邮箱格式不正确',
  phoneError: '号码格式不正确',
  whatsappError: 'What\'s app Number格式不正确',
  sendOk: '验证码已发送',
  pleaseEnterCode: '请先获取并填写验证码',
  add: '添加',
  currentPhone: '当前手机号: ',
  currentEmail: '当前What\'s App Number: ',
  currentWA: '当前邮箱: ',
  pleaseEnter: '请输入',
  pleaseSelect: '请选择'
}
